import type { Prodotto } from '../types';

export function productDisplayPrice(product: Pick<Prodotto, 'prezzo_unitario' | 'prezzo_listino_base' | 'listino_base_nome'>) {
  if (product.prezzo_listino_base != null) {
    return { amount: Number(product.prezzo_listino_base), source: product.listino_base_nome || 'Listino base' };
  }
  if (Number(product.prezzo_unitario) > 0) {
    return { amount: Number(product.prezzo_unitario), source: 'Prezzo anagrafico' };
  }
  return { amount: null, source: 'Prezzo non configurato' };
}
